import React, { useState } from "react";
import truncate from "html-truncate";
import classes from "./FitnessPreview.module.scss";
import { inlineifyHTML } from "./helpers/inlineifyHTML";

const MAX_CHARS = 190;

export default function ProgramOverview({ overview }) {
  const [expanded, setExpanded] = useState(false);

  const ALLOWED = /<\/?(?!b\b|strong\b|i\b|em\b)[a-z][^>]*>/gi;
  const safe = overview.replace(ALLOWED, "");

  // Flatten every block into inline spans
  const inlineHtml = inlineifyHTML(safe);

  //Truncate + inject inline “Show more”
  const clipped = truncate(inlineHtml, MAX_CHARS - 30, {
    ellipsis: `<span>...<span class="${classes.showMoreBtn}"> Show more</span></span>`
  });

  const handleClick = e => {
    if (
      e.target.classList.contains(classes.showMoreBtn) ||
      e.target.classList.contains(classes.showLessBtn)
    ) {
      setExpanded(x => !x);
    }
  };

  return (
    <div className={classes.sectionContainer}>
      <div className={classes.subheading}>Program Overview</div>
      <span
        className={classes.overviewText}
        onClick={handleClick}
        style={{ cursor: "default" }}
      >
        {!expanded ? (
          <span
            className={classes.collapsed}
            dangerouslySetInnerHTML={{ __html: clipped }}
          />
        ) : (
          <>
            <span
              className={classes.expanded}
              dangerouslySetInnerHTML={{ __html: inlineHtml }}
            />
            <span
              className={classes.showLessBtn}
              style={{
                marginLeft: "0.3ch",
                verticalAlign: "baseline",
                cursor: "pointer"
              }}
            >
              Show less
            </span>
          </>
        )}
      </span>
    </div>
  );
}


